import { Control } from '@peckadesign/pd-naja/dist/types'
import { getCookie, setCookie } from 'typescript-cookie'

class ChatControl implements Control {
	// The name of the cookie used to track whether the chat has been loaded at any point during the current session.
	// The cookie is valid for the lifetime of the browser tab or window.
	public static readonly COOKIE_NAME = 'dzWebChatOpened'

	// Indicates whether the chat has been loaded during the current page load (MPA).
	private isChatLoaded = false

	public initialize(context: Element | Document): void {
		const buttons = context.querySelectorAll<HTMLElement>('.js-open-chat')

		buttons.forEach((buton) => buton.addEventListener('click', this.handleClick.bind(this)))

		const alreadyOpened = getCookie(ChatControl.COOKIE_NAME)
		if (alreadyOpened) {
			this.loadChat(false)
		}
	}

	public handleClick(event: Event): void {
		event.preventDefault()

		if (this.isChatLoaded) {
			window.LiveChatWidget?.call('maximize')
		} else {
			this.loadChat(true)
		}

		// Trigger click on document so that the main menu is always closed
		document.body.click()
	}

	private loadChat(openOnLoad: boolean): void {
		if (!window.LiveChatWidget) {
			return
		}

		if (openOnLoad) {
			window.LiveChatWidget.once('ready', () => window.LiveChatWidget.call('maximize'))
		}

		window.LiveChatWidget.once('ready', this.chatLoadedCallback.bind(this))
		window.LiveChatWidget.init()
	}

	private chatLoadedCallback(): void {
		this.isChatLoaded = true

		setCookie(ChatControl.COOKIE_NAME, true)
	}
}

export default new ChatControl()
